import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class DownloadService {
  private readonly http = inject(HttpClient);

  trigger(path: string, params: Record<string, unknown> = {}): Observable<void> {
    return this.http
      .get<{ downloadToken: string }>('/admin/v2/integration-menu-item/download-token')
      .pipe(
        map(({ downloadToken }) => {
          const url = new URL(`${environment.apiUrl}${path}`);

          Object.entries(params).forEach(([key, value]) => {
            if (value == null) return;
            if (Array.isArray(value)) {
              value.forEach((v) => url.searchParams.append(key, String(v)));
            } else {
              url.searchParams.set(key, String(value));
            }
          });

          url.searchParams.set('token', downloadToken);

          const a = document.createElement('a');
          a.href = url.toString();
          a.click();
        }),
      );
  }
}
